import EtablissementPoleEmploiAffiliation from '@/generated/controls/etablissement/EtablissementPoleEmploiAffiliation.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementPoleEmploiAffiliation
})
